var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#f05237",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1055 2244 c-467 -41 -833 -319 -988 -751 -59 -165 -77 -398 -43 -576 86 -452 441 -807 893 -893 114 -22 302 -22 416 0 452 86 807 441 893 893 22 114 22 302 0 416 -75 394 -349 712 -733 850 -118 43 -321 71 -438 61z m247 -626 c75 -40 150 -121 179 -196 21 -52 23 -77 27 -282 4 -243 -2 -299 -45 -383 -65 -129 -230 -219 -373 -203 -58 7 -184 62 -213 94 -16 17 -14 21 33 67 44 43 53 48 68 37 129 -94 294 -56 358 82 23 49 24 61 24 266 0 118 -4 230 -10 249 -47 164 -257 220 -383 102 -128 -118 -74 -343 94 -391 19 -6 69 -10 111 -10 l78 0 0 -76 0 -77 -99 5 c-83 4 -108 10 -164 36 -236 110 -298 408 -125 598 119 129 291 162 440 82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroq);
export default __webpack_public_path__ + "static/media/groq.4f23c28d834dad598358f3ba084fe38b.svg";
export { ForwardRef as ReactComponent };